const columns = {
  portugues: {
    title: 'Colunas',
    subTitle: 'Conteúdo exclusivo dos nossos colunistas. Veja as últimas postagens',
    searchPlaceholder: 'Pesquise em colunas',
    readMore: 'Carregar mais colunas',
    imgDefault: {
      name: 'Nome da Modelo',
      src: 'https://api.belladasemana.com.br/storage/imagens/minhaconta-bg-model.jpg'
    },
    imgBannerRodape: {
      name: 'Nome Banner Rodape',
      src: 'https://api.belladasemana.com.br/storage/banners/1539015349.jpg'
    },
    wroteOn: 'escreveu em',
    share: 'Compartilhe',
    yoursComment: 'Deixe seu comentário',
    yourNickname: 'Seu nickname é',
    notYourNickName: 'não é',
    alterNickName: 'clique aqui para alterar',
    inputComment: 'Escreva seu comentário aqui',
    button: 'Enviar',
    subscriber: 'Assinante',
    commentAllBox: 'Veja todos os comentários',
    commentsColumn: 'comentários',
    formNewsCheck: 'Receber a newsletter do Bella da Semana',
    answer: 'Responder',
    yourName: 'Seu name',
    yourEmail: 'Seu email',
    publishedDate: 'Publicado em:',
    modifiedDate: 'Última atualização:',
    searchTerm: 'Buscando pelo termo:',
    searchNoRecords: 'Nenhum registro encontrado para o termo informado.',
    author: 'Autor(a)'
  },
  ingles: {
    title: 'Columns',
    subTitle: 'Exclusive content from our columnists. See the latest posts',
    searchPlaceholder: 'Search in columns',
    readMore: 'Read more columns',
    imgDefault: {
      name: 'Model Name',
      src: 'https://api.belladasemana.com.br/storage/imagens/minhaconta-bg-model.jpg'
    },
    imgBannerRodape: {
      name: 'Nome Banner Rodape',
      src: 'https://api.belladasemana.com.br/storage/banners/1539015349.jpg'
    },
    wroteOn: 'wrote on',
    share: 'Share',
    yoursComment: 'Leave your comment',
    yourNickname: 'Your nickname is',
    notYourNickName: 'Is not',
    alterNickName: 'click here to change',
    inputComment: 'Write your comment here',
    button: 'Send',
    subscriber: 'Subscriber',
    commentAllBox: 'See all comments',
    commentsColumn: 'comments',
    formNewsCheck: 'Receive the Bella Club newsletter',
    answer: 'Answer',
    yourName: 'Your name',
    yourEmail: 'Your e-mail',
    publishedDate: 'Posted in:',
    modifiedDate: 'Last modified:',
    searchTerm: 'Searching for the term:',
    searchNoRecords: 'No records found for the given term.',
    author: 'Author'
  }
}

export default columns
